import React from "react";
import PropTypes from "prop-types";
import "./pagination.scss";

const defaultButton = props => <button {...props}>{props.children}</button>;

export default class PaginationNew extends React.Component {
  constructor(props) {
    super();

    this.changePage = this.changePage.bind(this);

    this.state = {
      visiblePages: this.getVisiblePages(props.page, props.pages, props.context)
    };
  }

  static propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    PageButtonComponent: PropTypes.any,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string,
    context: PropTypes.string || 'normal'
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      //const visiblePages = this.getVisiblePages(null, nextProps.pages);
      this.setState({
        //visiblePages: this.filterPages(visiblePages, nextProps.pages)
        visiblePages: this.getVisiblePages(nextProps.page, nextProps.pages, nextProps.context)
      });
    }

    this.changePage(nextProps.page + 1);
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter(page => page <= totalPages);
  };

  // getVisiblePages = (page, total) => {

  //   if (total < 7) {
  //     return this.filterPages([1, 2, 3, 4, 5, 6], total);
  //   } else {
  //     if (page > 6 && page + 7 < total) {
  //       return [1, page - 1, page, page + 1, page + 2, page + 3, page + 4, page + 5, page + 6, total];
  //     } else if (page === total) {
  //       return [1, page - 8, page - 7, page - 6, page - 5, page - 4, page - 3, page - 2, page - 1, page];
  //     } else if (page + 8 > total) {
  //       return [1, page - 7, page - 6, page - 5, page - 4, page - 3, page - 2, page - 1, page, total];
  //     }
  //     else {
  //       return [1, 2, 3, 4, 5, 6, 7, 8, 9, total];
  //     }
  //   }
  // };

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
      if (page % 6 >= 0 && page > 7 && page + 8 < total) {
        return [1, '...', page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3, page + 4, page + 5, page + 6, '...', total]
      } else if (page === total) {
        return [1, page - 10, page - 9, page - 8, page - 7, page - 6, page - 5, page - 4, page - 3, page - 2, page - 1, page];
      } else if (page + 8 >= total) {
        return [1, '...', total - 9, total - 8, total - 7, total - 6, total - 5, total - 4, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '...', total];
      }
    }
  };
  changePage(page) {
    const activePage = this.props.page + 1;

    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages)
    });

    this.props.onPageChange(page - 1);
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props;
    const { visiblePages } = this.state;
    const activePage = this.props.page + 1;

    if (this.props.pages === 0) return (
      <div className="Table__pagination"></div>
    );

    return (
      <div className="Table__pagination">
        <div className="Table__prevPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === 1) return;
              this.changePage(activePage - 1);
            }}
            disabled={activePage === 1}
          >
            <img src="../../images/search/chevron-left.svg" alt=""></img> {this.props.previousText}
          </PageButtonComponent>
        </div>

        <div className="Table__visiblePagesWrapper">
          {visiblePages.map((page, index) => (
            <PageButtonComponent
              key={index}
              className={`${page === '...' ?
                'Table__pageButton--dot'
                :
                `${activePage === page ?
                  'Table__pageButton--active Table__pageButton'
                  : 'Table__pageButton'}`
                } }`
              }
              onClick={() => this.changePage(page)}
              disabled={page === '...'}
            >
              {page === this.props.pages ? page : page}
            </PageButtonComponent>
          ))}
        </div>

        <div className="Table__nextPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === this.props.pages) return;
              this.changePage(activePage + 1);
            }}
            disabled={activePage === this.props.pages}
          >
            {this.props.nextText}  <img src="../../images/search/chevron-rigth.svg" alt=""></img>
          </PageButtonComponent>
        </div>
      </div>
    );
  }
}
